module.exports = __webpack_public_path__ + "static/media/invoice_banner.d258a926.png";